import React, { Component } from "react";
import {connect} from 'react-redux';

import { ImageSelector } from '../Util/Util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { Alert,Button } from 'reactstrap';
import Ping from 'ping.js';

import '../Styles/ShortLink_Redirection.css';
import '../Styles/shared.css';
import 'bootstrap/dist/css/bootstrap.css';

class ShortLink_Redirection extends Component {

    state = { logo: '', Unreachable:false}


    constructor(props) {
        super(props)
        //console.log(this.props.Mylink.str_GUID)
        this.checkLabConnectivity = this.checkLabConnectivity.bind(this);
    }

     componentDidMount() {
        let logo = ImageSelector(this.props.Mylink.str_GUID)
        this.setState({logo:logo, Unreachable:false});


        setTimeout(function() { //Start the timer           
            this.checkLabConnectivity()
        }
        .bind(this), 30)

        
        setTimeout(function() { //Start the timer           
            window.location.href = atob(atob(this.props.Mylink.str_OrginalURL));
       }
       .bind(this), 1000)


     }


     checkLabConnectivity(){
        const URL = atob(atob(this.props.Mylink.str_OrginalURL));

        if (URL.replace("https://","").replace("http://","").indexOf("/") > -1)
        {
            var indexofslash = URL.replace("https://","").replace("http://","").indexOf("/");
            var IPAndPort = URL.replace("https://","").replace("http://","").substring(0,indexofslash);
            IPAndPort = 'http://' +  IPAndPort;

            var p = new Ping();
            p.timeout=3000;
            p.ping(IPAndPort, (err, data) => {
                if (err)
                {
                    console.log(IPAndPort + " is unreachable")
                    window.stop();
                    this.setState({ Unreachable:false });
                }
                else
                {
                    console.log(IPAndPort + " is reachable")
                    this.setState({ Unreachable:false });
                }
            });
        }
     }
 

    render(){


        let ServerUnreachable = this.state.Unreachable ?
            (
                <div>
                    <Alert className="content-text-center" color="danger">
                        <p className="content-text-center">متاسفانه سرور آزمایشگاه در دسترس نمی باشد. لطفا دقایقی دیگر مجددا تست یا با آزمایشگاه تماس بفرمایید.</p>
                        <Button color="success" className="mt-1">
                            <a className="content-text-center" href={"tel:" + this.props.Mylink.str_DirectTel} target="_blank">
                                <p className="lab-contact-text">تلفن تماس: {this.props.Mylink.str_DirectTel} <FontAwesomeIcon icon={faPhone}></FontAwesomeIcon> </p>                                
                            </a>
                        </Button>
                    </Alert>
                </div>
            )
            :
            (
                null
            )

        return(
            <div className="box">
                <div className="content"> 
                    <img className="animate img-fluid rounded-circle border lab-logo content-center mt-4 mb-3" src={this.state.logo} alt=""></img>
                    <h5 className="text-color-black content-text-center"> در حال اتصال به آزمایشگاه {this.props.Mylink.str_LabPersianName}</h5>
                    <a className="content-text-center" href={"tel:" + this.props.Mylink.str_DirectTel} target="_blank">
                         <p className="customer-logo-text text-muted">{this.props.Mylink.str_DirectTel} <FontAwesomeIcon icon={faPhone}></FontAwesomeIcon> </p>                                
                    </a>
                    {ServerUnreachable}
                </div>            
         </div>
        )
    }

}


const mapStateToProps = state => {
    const Mylink = state.Mylink;
    const UserAuthPass = state.UserAuthPass;
    return {Mylink,UserAuthPass}
};

export default connect(mapStateToProps)(ShortLink_Redirection)
// export default ShortLinkMainLayout